<template>
  <div>
    <ul class="area_diagnosis list-unstyled">
      <!-- Diagnosis 的選單 -->
      <li>
        <template v-if="header === 'Diagnosis'">
          <!-- Diagnosis 第一層選單 的標題樣式 -->
          <div class="page_titlebar diagnosis">
            <h2>{{ $t('diagnosis.diagnosisHeaderHome') }}</h2>
          </div>
        </template>
        <template v-else>
          <!-- Diagnosis 第二層選單 的標題樣式 -->
          <div class="page_titlebar page_diagnosisInside">
            <h2 :data-tit="$t('diagnosis.diagnosisHeader'+header)">
              {{ $t('diagnosis.diagnosisHeaderHome') }}
            </h2>
          </div>
        </template>

        <ul class="nav_diagnosis list-unstyled" ref="diagnosisDom">
          <li
            v-for="(diagnosis, index) in data"
            :id="'btn'+ diagnosis.id"
            :key="diagnosis.item"
            :class="{'d-active': index === activeNavIndex}"
            @mouseover="hoverOnStyle(index, diagnosis)"
            @click="funcHandleClick(index, diagnosis)">
            <router-link :to="`${diagnosis.path}`">
              <span
                class="listImg"
                :style="{backgroundImage: 'url('+loadImage(diagnosis)+')'}"
              ></span>
              <span>{{ $t('diagnosis.diagnosisItem.'+diagnosis.id) }}</span>
              <!-- HMI 勾和X -->
              <template v-if="diagnosisRecordName === 'hmi'">
                <!-- 分開： Display -->
                <template v-if="diagnosis.id === diagnosisResult.hmiPanel">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisHmiPanel.successCount"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
                <!-- 分開： Console -->
                <template v-if="diagnosis.id === diagnosisResult.hmiButton">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisHmiButton.successCount"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
                <!-- 結合+： DisplayConsole -->
                <template v-if="diagnosis.id === diagnosisResult.hmiDisplayConsole">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisHmiButton.successCount && getDiagnosisHmiPanel.successCount"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
              </template>
              <!-- Sensor 勾和X -->
              <template v-if="diagnosisRecordName === 'sensor'">
                <template v-if="diagnosis.id === diagnosisResult.speedSensor">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisSpeedSensor.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
                <template v-if="diagnosis.id === diagnosisResult.cadenceSensor">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisCadenceSensor.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
                <template v-if="diagnosis.id === diagnosisResult.torqueSensor">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisTorqueSensor.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
              </template>
              <!-- Driver 勾和X -->
              <template v-if="diagnosisRecordName === 'driver'">
                <template v-if="diagnosis.id === diagnosisResult.driver">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisDriver.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
              </template>
              <!-- Motor 勾和X -->
              <template v-if="diagnosisRecordName === 'motor'">
                <template v-if="diagnosis.id === diagnosisResult.motor">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisMotor.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
              </template>
              <!-- Battery 勾和X -->
              <template v-if="diagnosisRecordName === 'battery'">
                <template v-if="diagnosis.id === diagnosisResult.battery">
                  <span
                    class="recheck passed"
                    v-if="getDiagnosisBattery.status.result"
                  >
                  </span>
                  <span
                    class="recheck failed"
                    v-else
                  >
                  </span>
                </template>
              </template>

              <!-- All Record： 成功和失敗 -->
              <template v-if="diagnosisRecordName === 'allDiagnosis'">
                <ul class="showResult list-unstyled">
                  <!-- HMI -->
                  <template v-if="diagnosis.id === 'diagnosisHmi'">
                    <li
                      class="passed"
                      v-if="recordData.hmiDisplayConsole.passed > 0"
                    >
                      {{ recordData.hmiDisplayConsole.passed }} {{ $t('diagnosis.result.passed') }}
                    </li>
                    <li
                      class="failed"
                      v-if="recordData.hmiDisplayConsole.failed > 0"
                    >
                      {{ recordData.hmiDisplayConsole.failed }} {{ $t('diagnosis.result.failed') }}
                    </li>
                  </template>
                  <!-- Driver -->
                  <template v-else-if="diagnosis.id === 'diagnosisDriver'">
                    <li
                      class="passed"
                      v-if="recordData.driver.passed > 0"
                    >
                      {{ recordData.driver.passed }} {{ $t('diagnosis.result.passed') }}
                    </li>
                    <li
                      class="failed"
                      v-if="recordData.driver.failed > 0"
                    >
                      {{ recordData.driver.failed }} {{ $t('diagnosis.result.failed') }}
                    </li>
                  </template>
                  <!-- Motor -->
                  <template v-else-if="diagnosis.id === 'diagnosisMotor'">
                    <li
                      class="passed"
                      v-if="recordData.motor.passed > 0"
                    >
                      {{ recordData.motor.passed }} {{ $t('diagnosis.result.passed') }}
                    </li>
                    <li
                      class="failed"
                      v-if="recordData.motor.failed > 0"
                    >
                      {{ recordData.motor.failed }} {{ $t('diagnosis.result.failed') }}
                    </li>
                  </template>
                  <!-- Sensor -->
                  <template v-else-if="diagnosis.id === 'diagnosisSensor'">
                    <li
                      class="passed"
                      v-if="recordData.sensor.passed > 0"
                    >
                     {{ recordData.sensor.passed }} {{ $t('diagnosis.result.passed') }}
                    </li>
                    <li
                      class="failed"
                      v-if="recordData.sensor.failed > 0"
                    >
                      {{ recordData.sensor.failed }} {{ $t('diagnosis.result.failed') }}
                    </li>
                  </template>
                  <!-- Battery -->
                  <template v-else-if="diagnosis.id === 'diagnosisBattery'">
                    <li
                      class="passed"
                      v-if="recordData.battery.passed > 0"
                    >
                      {{ recordData.battery.passed }} {{ $t('diagnosis.result.passed') }}
                    </li>
                    <li
                      class="failed"
                      v-if="recordData.battery.failed > 0"
                    >
                      {{ recordData.battery.failed }} {{ $t('diagnosis.result.failed') }}
                    </li>
                  </template>
                </ul>
              </template>
            </router-link>
          </li>
        </ul>
      </li>
      <!-- Up/Down/Power Btns -->
      <li>
        <Operator
          :modalOpen="show"
          :btnText="{
            up: $t('diagnosis.btnHome.up'),
            down: $t('diagnosis.btnHome.down'),
            power: $t('diagnosis.btnHome.power')
          }"
          @keyUpEvent="funcHandleUp"
          @keyDownEvent="funcHandleDown"
          @keyPowerEvent="funcHandlePower"
        />
      </li>
    </ul>
    <Modal
      :btnHmi="{up: '', down: $t('diagnosis.btnStep.cancel'), power: $t('diagnosis.btnStep.start')}"
      :open="show"
      @specialHmi="funcHandleSpecialHmi"
      @keyUpEvent="funcHandleUp"
      @keyDownEvent="funcHandleDown"
      @keyPowerEvent="funcHandlePower"
      :title="title"
      :itemId="itemId"
      :btn="btnStep"
      :bikeVal="bikeVal"
      :bikeStatus="bikeStatus"
      :bikeErrorCode="bikeErrorCode"
      :content="content"
      :seconds="seconds"
    />
    <uiv-modal v-model="modalOpenDisconnect" class="v-modal-style" :backdrop="false">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          id="btnOK"
          type="button"
          class="btn btn-default"
          @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
  </div>
</template>
<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/return-in-computed-property */
/* eslint-disable no-unused-expressions */

import _ from 'lodash';
import Operator from './Operator';
import Modal from './Modal';
import { websocketAPI, diagnosisAPI } from '@/mixins/websocket-api';
import { mapGetters } from 'vuex';
import { funcWebDiagnosis } from '@/utils/web-style/web-style';

export default {
  name: 'DiagnosisMenuItem',
  props: ['data', 'header'],
  mixins: [websocketAPI, diagnosisAPI],
  components: {
    Operator,
    Modal
  },
  data () {
    return {
      modalOpenDisconnect: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: this.$t('bikeOverview.modalContent')
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        }
      },
      boolDisconnect: true,
      specialHmi: {},
      activeNavIndex: 0,
      location: 0,
      keyboard: 'ArrowDown',
      show: false,
      bikeVal: '',
      bikeStatus: '',
      bikeErrorCode: '',
      btnStep: this.$t('diagnosis.btnStep.start'),
      content: {},
      // 紀錄診斷成功與失敗
      recordData: {
        sensor: {
          passed: [],
          failed: []
        },
        driver: {
          passed: [],
          failed: []
        },
        motor: {
          passed: [],
          failed: []
        },
        battery: {
          passed: [],
          failed: []
        },
        hmiDisplayConsole: {
          passed: [],
          failed: []
        }
      },
      setSensorTime: {
        second: 20,
        count: 1
      }
    };
  },
  mounted () {
    this.allSensorRecord;
    this.allMotorRecord;
    this.allDriverRecord;
    this.allBatteryRecord;

    // 偵測Up button
    this.ws.onDetectUpBtn = (data) => {
      if (this.show && this.$route.meta.id !== 'hmi') return;
      // 是給hmi button處理
      if (this.show && this.$route.meta.id === 'hmi') {
        switch (this.specialHmi.up) {
          case 'Yes':
            this.funcHandleUp('counter', 'Up');
            break;
        }
      } else this.funcHandleUp('arrowUp');
    };

    // 偵測Down button
    this.ws.onDetectDownBtn = (data) => {
      if (this.show && this.$route.meta.id !== 'hmi') {
        // 當finish的時候 cancelbtn不能點
        if (this.bikeStatus === 1001 || this.bikeStatus === 1000) return;
        this.funcHandleDown('cancel');
      } else if (this.show && this.$route.meta.id === 'hmi') {
        // 是給hmi button處理
        switch (this.specialHmi.down) {
          case 'No':
            this.funcHandleDown('counter', 'Down');
            break;
          case 'Cancel':
            this.funcHandleDown('counter', 'cancel');
            break;
        }
      } else this.funcHandleDown('arrowDown');
    };

    // 偵測Power button
    this.ws.onDetectPowerBtn = (data) => {
      if (this.show && this.$route.meta.id !== 'hmi') {
        this.funcHandlePower('counter');
      } else if (this.show && this.$route.meta.id === 'hmi') {
        // 是給hmi button處理
        switch (this.specialHmi.power) {
          case 'Cancel':
            this.funcHandlePower('counter', 'cancelPower');
            break;
          case 'Enter':
            this.funcHandlePower('counter', 'start');
            break;
          case 'Finish':
            this.funcHandlePower('counter', 'finish');
            break;
          default:
            this.funcHandlePower('counter');
        }
      } else this.funcHandlePower('power');
    };

    // 列表高度
    funcWebDiagnosis();
    // // console.log(this);
  },
  beforeUpdate () {
    this.allSensorRecord;
    this.allDriverRecord;
    this.allMotorRecord;
    this.allBatteryRecord;
    this.allHMIDisplayConsoleRecord;
  },
  watch: {
    show (val) {
      this.createBeforeunloadHandler();
      this.$store.dispatch('diagnosis/setModelOpenState', true);
      if (!val) {
        // 啟動keep connect
        this.destroyedBeforeunloadHandler();
        this.$store.dispatch('diagnosis/setModelOpenState', false);
        this.funcTimeInterval();
        // console.log('call keep connect => diagnosis show = false')
        this.bikeStatus = '';
        this.bikeErrorCode = '';
        this.bikeVal = '';
      }
    }
  },
  computed: {
    title () {
      // 標題
      return this.$t('diagnosis.diagnosisItem.' + this.data[this.location].id);
    },
    itemId () {
      // this.content = content(this.data[this.location].id)
      // this.content = this.$t('diagnosis.diagnosisContent.' + this.data[this.location].id);
      // console.log('this.data[this.location].id', this.data[this.location].id)
      return this.data[this.location].id;
    },
    ...mapGetters({
      getLcm: 'diagnosis/getLcm',
      getDisp: 'diagnosis/getDisp',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList',
      getDiagnosisSpeedSensor: 'diagnosis/getDiagnosisSpeedSensor',
      getDiagnosisCadenceSensor: 'diagnosis/getDiagnosisCadenceSensor',
      getDiagnosisTorqueSensor: 'diagnosis/getDiagnosisTorqueSensor',
      getDiagnosisDriver: 'diagnosis/getDiagnosisDriver',
      getDiagnosisMotor: 'diagnosis/getDiagnosisMotor',
      getDiagnosisBattery: 'diagnosis/getDiagnosisBattery',
      getDiagnosisHmiButton: 'diagnosis/getDiagnosisHmiButton',
      getDiagnosisHmiPanel: 'diagnosis/getDiagnosisHmiPanel'
    }),
    diagnosisRecordName () {
      return this.$route.meta.id;
    },
    diagnosisResult () {
      const speedSensor = this.getDiagnosisSpeedSensor;
      const cadenceSensor = this.getDiagnosisCadenceSensor;
      const torqueSensor = this.getDiagnosisTorqueSensor;
      const driver = this.getDiagnosisDriver;
      const motor = this.getDiagnosisMotor;
      const battery = this.getDiagnosisBattery;
      const hmiPanel = this.getDiagnosisHmiPanel;
      const hmiButton = this.getDiagnosisHmiButton;

      const obj = {};

      if (speedSensor !== null) obj['speedSensor'] = speedSensor.status.id;
      if (cadenceSensor !== null) obj['cadenceSensor'] = cadenceSensor.status.id;
      if (torqueSensor !== null) obj['torqueSensor'] = torqueSensor.status.id;

      if (driver !== null) obj['driver'] = driver.status.title;
      if (motor !== null) obj['motor'] = motor.status.title;
      if (battery !== null) obj['battery'] = battery.status.title;

      if (hmiPanel !== null) obj['hmiPanel'] = 'diagnosisHmiDisplay';
      if (hmiButton !== null) obj['hmiButton'] = 'diagnosisHmiConsole';
      if (obj['hmiPanel'] && obj['hmiButton'] && this.getDisp) {
        obj['hmiDisplayConsole'] = 'diagnosisHmiDisplayConsole';
      }

      return obj;
    },
    allSensorRecord () {
      const speedSensor = this.getDiagnosisSpeedSensor;
      const cadenceSensor = this.getDiagnosisCadenceSensor;
      const torqueSensor = this.getDiagnosisTorqueSensor;

      const result = [];
      const passed = [];
      const failed = [];

      if (speedSensor !== null) result.push(speedSensor.status);
      if (cadenceSensor !== null) result.push(cadenceSensor.status);
      if (torqueSensor !== null) result.push(torqueSensor.status);

      result.map(item => {
        if (item.result) {
          return passed.push(item);
        } else if (item.result === false) {
          return failed.push(item);
        }
      });

      this.recordData.sensor.passed = passed.length;
      this.recordData.sensor.failed = failed.length;
    },
    allDriverRecord () {
      const driver = this.getDiagnosisDriver;

      const result = [];
      const passed = [];
      const failed = [];

      if (driver !== null) result.push(driver.status);

      result.map(item => {
        if (item.result) {
          return passed.push(item);
        } else if (item.result === false) {
          return failed.push(item);
        }
      });

      this.recordData.driver.passed = passed.length;
      this.recordData.driver.failed = failed.length;
    },
    allMotorRecord () {
      const motor = this.getDiagnosisMotor;
      // console.log("TCL: allMotorRecord -> this.getDiagnosisMotor", this.getDiagnosisMotor)

      const result = [];
      const passed = [];
      const failed = [];

      if (motor !== null) result.push(motor.status);

      result.map(item => {
        if (item.result) {
          return passed.push(item);
        } else if (item.result === false) {
          return failed.push(item);
        }
      });

      this.recordData.motor.passed = passed.length;
      this.recordData.motor.failed = failed.length;
    },
    allBatteryRecord () {
      const battery = this.getDiagnosisBattery;

      const result = [];
      const passed = [];
      const failed = [];

      if (battery !== null) result.push(battery.status);

      result.map(item => {
        if (item.result) {
          return passed.push(item);
        } else if (item.result === false) {
          return failed.push(item);
        }
      });

      this.recordData.battery.passed = passed.length;
      this.recordData.battery.failed = failed.length;
    },
    allHMIDisplayConsoleRecord () {
      const hmiPanel = this.getDiagnosisHmiPanel;
      const hmiButton = this.getDiagnosisHmiButton;

      const panelResult = [];
      const buttonResult = [];
      let passed = [];
      let failed = [];

      if (hmiPanel !== null) panelResult.push(hmiPanel);
      if (hmiButton !== null) buttonResult.push(hmiButton);

      panelResult.map(item => {
        if (item.successCount) {
          return passed.push(item);
        } else if (item.failedCount) {
          return failed.push(item);
        }
      });
      buttonResult.map(item => {
        if (item.successCount) {
          return passed.push(item);
        } else if (item.failedCount) {
          return failed.push(item);
        }
      });
      // /**
      //  * getDisp
      //  * @type {boolean}
      //  * @desc 主要是分辨display和console是否分開。
      //  */
      if (this.getDisp) {
        if (failed.length > 0) this.recordData.hmiDisplayConsole.failed = 1;
        else if (passed.length > 0 && failed <= 0) this.recordData.hmiDisplayConsole.passed = 1;
      } else {
        this.recordData.hmiDisplayConsole.passed = passed.length;
        this.recordData.hmiDisplayConsole.failed = failed.length;
      }
    },
    failedList () {
      const speedSonsor = this.getDiagnosisSpeedSensor;
      const cadenceSensor = this.getDiagnosisCadenceSensor;
      const torqueSensor = this.getDiagnosisTorqueSensor;
      // const driver = this.getDiagnosisDriver;
      const motor = this.getDiagnosisMotor;
      const battery = this.getDiagnosisBattery;
      const hmiButton = this.getDiagnosisHmiButton;
      const hmiPanel = this.getDiagnosisHmiPanel;

      const arr = [];

      if (this.test(speedSonsor)) {
        arr.push({
          id: 'speedSonsor',
          title: 'Speed sensor',
          result: 'failure'
        });
      }
      if (this.test(cadenceSensor)) {
        arr.push({
          id: 'cadenceSonsor',
          title: 'Cadence sensor',
          result: 'failure'
        });
      }
      if (this.test(torqueSensor)) {
        arr.push({
          id: 'torqueSonsor',
          title: 'Torque sensor',
          result: 'failure'
        });
      }
      if (this.test(motor)) {
        arr.push({
          id: 'motor',
          title: 'Motor',
          result: 'failure'
        });
      }
      if (this.test(battery)) {
        arr.push({
          id: 'battery',
          title: 'Battery',
          result: 'failure'
        });
      }
      // HMI
      if (hmiButton) {
        if (hmiButton.failedCount) {
          arr.push({
            id: 'console',
            title: 'Console',
            result: 'failure'
          });
        }
      }

      if (hmiPanel) {
        if (hmiPanel.failedCount) {
          arr.push({
            id: 'display',
            title: 'Display',
            result: 'failure'
          });
        }
      }
      return arr;
    },
    reportList () {
      return {
        TodayWork: {
          Maintenance: this.getAllBikeInfoList.bikeInfoList ? this.getAllBikeInfoList.bikeInfoList.NextMaintenance : '',
          SystemDiagnosis: this.failedList.map(item => item.title).join(',')
        }
      };
    }
  },
  beforeDestroy () {
    // 移除beforeunload事件
    this.destroyedBeforeunloadHandler();
    this.$store.dispatch('bikeReport/setCreateReport', this.reportList);
  },
  methods: {
    funcBrowserClose (e) {
      e.preventDefault();
      e.returnValue = '';
    },
    createBeforeunloadHandler () {
      window.addEventListener('beforeunload', this.funcBrowserClose, false);
    },
    destroyedBeforeunloadHandler () {
      window.removeEventListener('beforeunload', this.funcBrowserClose, false);
    },
    hoverOnStyle (index, diagnosis) {
      this.location = index;
      this.activeNavIndex = this.location;
    },
    funcOkBtnDialog () {
      if (this.boolDisconnect) {
        this.modalOpenDisconnect = false;
        this.ws.CancelDiagnosis();
        $('#bike_Testing').modal('hide');
        this.show = false;

        setTimeout(() => {
          this.$router.push('/connect');
        }, 300);
      }
    },
    test (val) {
      return val !== null ? !(val.status.result) : undefined;
    },
    funcBtnStep (power) {
      /**
       * funcBtnStep： 被modal呼叫此函數
       * 根據判斷語句來決定呼叫哪個指令
       */
      // 開始
      if (power.name === 'motorbattery' && power.action === 'processing') {
        // 關閉keep connect
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu motorbattery line593')
        switch (this.itemId) {
          case 'diagnosisDriver':
            this.ws.DiagnosisController(20, 1);
            break;
          case 'diagnosisMotor':
            this.ws.DiagnosisMotor(20, 1);
            break;
          case 'diagnosisBattery':
            this.ws.DiagnosisBattery(20, 1);
            break;
        }
      } else if (power.name === 'diagnosisHmiDisplayConsole' && power.action === 'LCDBtn') {
        // 關閉keep connect
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu diagnosisHmiDisplayConsole line606')
        switch (this.itemId) {
          case 'diagnosisHmiDisplayConsole':
            this.ws.DiagnosisDisplayFlash();
            break;
          case 'diagnosisHmiDisplay':
            this.ws.DiagnosisDisplayFlash();
            break;
        }
      } else if (power.name === 'sensor' && power.action === 'countDown') {
        // 關閉keep connect
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu sensor line619')
        // 測試 Sensor
        switch (this.itemId) {
          case 'diagnosisSpeedSensor':
            this.ws.DiagnosisSpeedSensor(this.setSensorTime.second, this.setSensorTime.count);
            break;
          case 'diagnosisCadenceSensor':
            this.ws.DiagnosisCadenceSensor(this.setSensorTime.second, this.setSensorTime.count);
            break;
          case 'diagnosisTorqueSensor':
            this.ws.DiagnosisTorqueSensor(this.setSensorTime.second, this.setSensorTime.count);
            break;
        }
      } else if (power.name === 'Next' && power.action === 'upBtn') {
        // 測試HMI
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu Next upBtn line636')
        switch (this.itemId) {
          case 'diagnosisHmiDisplayConsole':
            this.ws.DiagnosisConsoleBtns(['u'], 10);
            this.ws.StopListenBtn();
            break;
          case 'diagnosisHmiConsole':
            this.ws.DiagnosisConsoleBtns(['u'], 10);
            this.ws.StopListenBtn();
            break;
        }
      } else if (power.name === 'Next' && power.action === 'downBtn') {
        // 測試HMI
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu Next downBtn line651')
        this.bikeVal = '';
        switch (this.itemId) {
          case 'diagnosisHmiDisplayConsole':
            this.ws.DiagnosisConsoleBtns(['d'], 10);
            break;
          case 'diagnosisHmiConsole':
            this.ws.DiagnosisConsoleBtns(['d'], 10);
            break;
        }
      } else if (power.name === 'Next' && power.action === 'powerBtn') {
        // 測試HMI
        clearInterval(this.timeInterval);
        // console.log('close keep connect => menu Next powerBtn line665')
        this.bikeVal = '';
        switch (this.itemId) {
          case 'diagnosisHmiDisplayConsole':
            this.ws.DiagnosisConsoleBtns(['w'], 10);
            break;
          case 'diagnosisHmiConsole':
            this.ws.DiagnosisConsoleBtns(['w'], 10);
            break;
        }
      } else if (power.name === 'Next' && power.action === 'finish') {
        this.ws.StartListenBtn();
      } else if (power.action === 'finish') {
        // Finish關閉modal
        $('#bike_Testing').modal('hide');
        this.show = false;
      }
    },
    loadImage (diagnosis) {
      // // console.log(Object.assign({}, diagnosis))
      return require(`@/assets/images/diagnosis/${diagnosis.img}`);
    },
    funcScrollDom (node, key) {
      /**
       * if diagnosisDom的捲動的高度是0，捲動到相對位置
       * else if diagnosisDom的捲動的高度大於0，
       * 會根據目前捲動的高度的值+想要捲動到相對位置的值
       */
      // window.scrollTo(0,0)
      if (this.activeNavIndex === 0) {
        node.scrollTo(0, 0);
      } else {
        // else if (node.scrollTop === 100 && key ==='up') {node.scrollTo(0, 30)}
        if (node.scrollTop >= 0) {
          switch (key) {
            case ('up'):
              node.scrollTo(0, node.scrollTop - 50);
              break;
            case ('down'):
              node.scrollTo(0, node.scrollTop + 100);
              break;
          }
        }
      }
    },
    funcHandleClick (index, diagnosis) {
      if (diagnosis.path === '') {
        this.location = index;
        this.activeNavIndex = this.location;
        this.show = true;
        this.content = this.$t('diagnosis.diagnosisContent.' + this.data[this.location].id);
        this.btnStep = this.$t('diagnosis.btnStep.start');
      }
    },
    funcHandleUp: _.debounce(function (key, text) {
      if (key === 'arrowUp') {
        if (this.location === 0) return;
        this.activeNavIndex = --this.location;
        this.funcScrollDom(this.$refs.diagnosisDom, 'up');
      } else if (key === 'counter') {
        // 當在bike console去操作會觸發一個事件
        this.$bus.$emit('powerClick', text);
      } else if (key === 'Yes') {
        // 測試button panel
        this.ws.DiagnosisDisplayTestStop();
      }
    }, 200),
    funcHandleDown: _.debounce(function (key, text) {
      if (key === 'arrowDown') {
        // 如果現在位置的值已經等於最大index -1，表示不能往下移動
        if (this.location === (this.data.length - 1)) return;
        this.activeNavIndex = ++this.location;
        this.funcScrollDom(this.$refs.diagnosisDom, 'down');
      } else if (key === 'counter') {
        // 當在bike console去操作會觸發一個事件
        this.$bus.$emit('powerClick', text);
      } else if (key === 'cancel') {
        this.ws.CancelDiagnosis();
        $('#bike_Testing').modal('hide');
        this.show = false;
      } else if (key === 'No') {
        // 測試button panel
        this.ws.DiagnosisDisplayTestStop();
      }
    }, 200),
    funcHandlePower: _.debounce(function (power, text) {
      this.seconds = 0;
      if (power === 'power') {
        if (this.data[this.location].path !== '') {
          this.$router.push(`${this.data[this.location].path}`);
        } else {
          $('#bike_Testing').modal();
          this.show = true;
          this.btnStep = this.$t('diagnosis.btnStep.start');
        }
      }
      // 當在bike console去操作會觸發一個事件
      if (power === 'counter') {
        this.$bus.$emit('powerClick', text);
      } else if (power === 'cancel') {
        this.ws.CancelDiagnosis(); // 關閉MG執行緒
        this.ws.DiagnosisDisplayTestStop(); // 關閉Display閃爍
        $('#bike_Testing').modal('hide');
        this.show = false;
      }
      // modal
      this.funcBtnStep(power);
    }, 200),
    funcHandleSpecialHmi (obj) {
      // 存放hmi btn名稱
      this.specialHmi = obj;
    }
  }
};
</script>
